export enum RootMutations {
  SET_LOADING = "SET_LOADING",
}
